import type {SinglePointRenderMode} from '../types';

export type SinglePointRenderOption = {
  value: SinglePointRenderMode;
  label: string;
};

export const SINGLE_POINTS_RENDER_OPTIONS: SinglePointRenderOption[] = [
  {value: 'scatter', label: 'Scatter'},
  {value: 'bar', label: 'Bar chart'},
];
